import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const getSocioEconomic = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api     
    .get(excludeChars ? `${url.stage.socioeconomicLevel}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.socioeconomicLevel}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})    
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newSocioEconomic = async data =>
  api
    .post(url.stage.socioeconomicLevel, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editSocioEconomic = async (stateId, data) =>
  api
    .put(`${url.stage.socioeconomicLevel}/${stateId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeSocioEconomic = async stateId =>
  api
    .remove(`${url.stage.socioeconomicLevel}/${stateId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getSocioEconomic,
  newSocioEconomic,
  editSocioEconomic,
  removeSocioEconomic,
}
